{
  "name": "Carson, Los Angeles",
  "events": [
    { "seconds": 30, "frequency": 410, "duration": 0.4 },
    { "seconds": 10, "frequency": 410, "duration": 1.0 },
    { "seconds": 5, "frequency": 410, "duration": 0.2 },
    { "seconds": 4, "frequency": 410, "duration": 0.2 },
    { "seconds": 3, "frequency": 410, "duration": 0.2 },
    { "seconds": 2, "frequency": 410, "duration": 0.2 },
    { "seconds": 1, "frequency": 410, "duration": 0.2 },
    { "seconds": 0, "frequency": 820, "duration": 0.2 }
  ]
}
